/**
 * Donnée CRT
 */
export interface CrtData {
  /**
   * id
   */
  id: number;
  /**
   * description de la donnée
   */
  descriptionDonnee: string;
  /**
   * descriptions des niveaux hierarchique
   */
  descriptionHierarNiv1: string;
  descriptionHierarNiv2: string;
  descriptionHierarNiv3: string;
  identifiantOh: number;
  idHierarNiv1: number;
  idHierarNiv2: number;
  idHierarNiv3: number;
  /**
   * description metier
   */
  descriptionMetier: string;
  /**
   * description site
   */
  libelleSite: string;
  /**
   * description site secondaire
   */
  libelleInstallation: string;
  /**
   * type CRT de la donnée
   */
  type: CrtDataType;
  /**
   * type de la valeur
   */
  typeValeur: CrtTypeValeur;
  /**
   * unité de la valeur
   */
  unite: string;
  /**
   * format d'affichage de la donnée
   */
  formatAffichage: string;
  /**
   * Priorite d'affichage
   */
  prioriAff: number;
  /**
   * valeur CRT de la donnée
   */
  valeurCRT: string | number;
  /**
   * valeur site de la donnée
   */
  valeurSite: string | number;
  /**
   * Réglage conseillé
   */
  valeurConseille: string | number;
  /**
   * Date
   */
  horodateCourant: Date;
  /**
   * Date de derniere saisie
   */
  horodateDerniereSaisie: Date;
  /**
   * Est une donnée favoris
   */
  estFavoris: boolean;
  /**
   * Est une donéne historique
   */
  estHistorique: boolean;
  /**
   * données historiques
   */
  valeursHistorique?: CrtDataHistoricValue[];
  /**
   * Libellés
   */
  associationLibelle: { defautLibelle: string; libelles: CrtDataLabel[] };
  /**
   * Est discordant
   */
  discordant: boolean;
  /**
   * Envoie en cours (statut intérmediaire)
   */
  envoieEnCours?: boolean;
  /**
   * Précision de la discordance
   */
  precisionDiscordance: number;
  /**
   * Information de la donnée historique
   */
  informationsHistorique: {
    horodatePremierHistorique: Date;
    horodateDernierHistorique: Date;
    valeurDernierHistorique: number;
  };
  /**
   * Plage de saisie
   */
  plageDeSaisie: boolean;
  /**
   * Plage mini
   */
  plageMinimum: number;
  /**
   * Plage maxi
   */
  plageMaximum: number;
  /**
   * est en maintenance
   */
  maintenance: boolean;
  /**
   * est bloqué
   */
  blocage: boolean;
  /**
   * est site bloqué
   */
  blocageSite: boolean;
  /**
   * si bloqué, date de début de blocage
   */
  dateDebutBlocage?: string;
  /**
   * si bloqué, date de fin de blocage
   */
  dateFinBlocage?: string;
  /**
   * dkCodeRessource du demandeur de blocage
   */
  dkCodeRessourceDemandeurBlocage?: string;
  /**
   * Nom Prenom du demandeur de blocage
   */
  nomPrenomRessourceDemandeurBlocage?: string;
  /**
   * dkCodeRessource de l'acteur de blocage
   */
  dkCodeRessourceActeurBlocage?: string;
  /**
   * Nom prenom de l'acteur de blocage
   */
  nomPrenomRessourceActeurBlocage?: string;
  /**
   * commentaire du blocage
   */
  commentaireBlocage?: string;
  /**
   * est en invalidation
   */
  invalidation: boolean;
  /**
   * Type du métier de la donnée
   */
  typeMetier: CrtTypeMetier;
  /**
   * Etat envoi
   */
  etatEnvoi: boolean | number;
  /**
   * DkCodeInstallation
   * DkCodeInstallation
   */
  dkCodeInstallation: string;

  disparition: boolean;
  /**
   * Libellé priorité
   */
  priorite: DataPriority;

  /**
   * Identifiant du site alarming de la donnée
   */
  idSiteAlarming: number;

  /**
   * DkCode Site du site alarming de la donnée
   */
  dkCodeSiteAlarming: string;

  /**
   * Libellé du site alarming de la donnée
   */
  libelleSiteAlarming: string;

  /**
   * Donnee système ou non
   */
  estSysteme: boolean;

  /**
   * Etat fonctionnel de la donnée
   */
  etatFonctionnel: string;
}

/**
 * Donnée Historique CRT
 */
export interface CrtDataHistoricValue {
  /**
   * date de la donnée
   */
  horodatage: Date;
  /**
   * valeur
   */
  valeur: number;
}

/**
 * Label d'une donnée
 */
export interface CrtDataLabel {
  /**
   * type de label
   */
  typePlage: CrtDataLabelType;
  /**
   * libelle
   */
  libelle: string;
  /**
   * valeur mini (si type de label = plage)
   */
  valeurMinimun: number;
  /**
   * valeur maxi (si type de label = plage)
   */
  valeurMaximun: number;
  /**
   * valeur (si type de label = point)
   */
  valeur: number;
}

/**
 * Type de label
 */
export enum CrtDataLabelType {
  /**
   * plage
   */
  PLAGE = 'PLAGE',
  /**
   * point
   * @type {string}
   */
  POINT = 'POINT',
}

export enum CrtTypeMetier {
  LGI = 'lgi',
  OSE = 'ose',
  OCT = 'oct',
  OTL = 'otl',
  OPG = 'opg',
  OS = 'os',
  LGU = 'lgu',
  OL5 = 'ol5',
  OL3 = 'ol3',
  OT = 'ot',
  OCE = 'oce',
  OPH = 'oph',
  OL2 = 'ol2',
  OE = 'oe',
  OLC = 'olc',
}

/**
 * Type de valeur
 */
export enum CrtTypeValeur {
  /**
   * reel
   */
  REEL = 'REEL',
  /**
   * entier
   * @type {string}
   */
  ENTIER = 'ENTIER',
  /**
   * logique
   * @type {string}
   */
  LOGIQUE = 'LOGIQUE',
}

/**
 * Type CRT de la donnée
 */
export enum CrtDataType {
  /**
   * tm
   */
  TM = 'TM',
  /**
   * tr
   * @type {string}
   */
  TR = 'TR',
  /**
   * ts
   * @type {string}
   */
  TS = 'TS',
  /**
   * tc
   * @type {string}
   */
  TC = 'TC',
  /**
   * tmh
   * @type {string}
   */
  TMH = 'TMH',
  /**
   * tmi
   * @type {string}
   */
  TMI = 'TMI',
  /**
   * tmp
   * @type {string}
   */
  TMP = 'TMP',
  /**
   * tsp
   * @type {string}
   */
  TSP = 'TSP',
  /**
   * tmt
   * @type {string}
   */
  TMT = 'TMT',
  /**
   * trt
   * @type {string}
   */
  TRT = 'TRT',
}

/**
 * Type de filtre
 */
export enum DonneeFilterType {
  /**
   * Mesures
   */
  MESURES = 'Mesures',
  /**
   * Reglages
   * @type {string}
   */
  REGLAGES = 'Réglages',
  /**
   * Commandes
   * @type {string}
   */
  COMMANDES = 'Commandes',
  /**
   * Signaux
   * @type {string}
   */
  ETATS_DEFAUTS = 'Etats / Défauts',
}

/**
 * Type de donnée
 */
export enum DonneeType {
  /**
   * Numerique
   */
  NUMERIQUE,
  /**
   * Vrai/Faux
   */
  BOOLEAN,
  /**
   * Texte
   */
  TEXTE,
  /**
   * Libellé
   */
  LIBELLE,
}

/**
 * Profondeur de la donnée historique
 */
export enum ProfondeurHistorique {
  /**
   * Mois
   */
  MOIS = 31,
  /**
   * Semaine
   * @type {number}
   */
  SEMAINE = 7,
  /**
   * Jour
   * @type {number}
   */
  JOUR = 1,
}

/**
 * Mapping data type to filter typer
 * @param dataType
 */
export const DataTypeToDataFilterType = (dataType: CrtDataType): DonneeFilterType => {
  switch (dataType) {
    case CrtDataType.TM:
    case CrtDataType.TMI:
    case CrtDataType.TMP:
    case CrtDataType.TMH:
    case CrtDataType.TMT:
      return DonneeFilterType.MESURES;
    case CrtDataType.TR:
    case CrtDataType.TRT:
      return DonneeFilterType.REGLAGES;
    case CrtDataType.TS:
    case CrtDataType.TSP:
      return DonneeFilterType.ETATS_DEFAUTS;
    case CrtDataType.TC:
      return DonneeFilterType.COMMANDES;
  }
};
/**
 * Mapping filter type to data type
 * @param filterType
 */
export const DataFilterTypeToDataTypes = (filterType: DonneeFilterType | string): CrtDataType[] => {
  switch (filterType) {
    case DonneeFilterType.MESURES:
      return [CrtDataType.TM, CrtDataType.TMI, CrtDataType.TMP, CrtDataType.TMH, CrtDataType.TMT];
    case DonneeFilterType.REGLAGES:
      return [CrtDataType.TR, CrtDataType.TRT];
    case DonneeFilterType.ETATS_DEFAUTS:
      return [CrtDataType.TS, CrtDataType.TSP];
    case DonneeFilterType.COMMANDES:
      return [CrtDataType.TC];
    default:
      return [];
  }
};

/**
 * Groupe d'historique
 */
export interface HistoricGroup {
  /**
   * identifiant
   */
  identifiant: number;
  /**
   * description
   */
  description: string;
  /**
   * tableau d'identifiants des données historiques du groupe
   */
  historiques: HistoricDataColor[];
  /**
   * Est une donnée favoris
   */
  estFavoris: boolean;
  /**
   * groupe historique en cours de modification
   * (en cours d'ajout ou de suppression au favoris)
   */
  isUpdating: boolean;
}

/**
 * Liaison entre une donnée et sa couleur de courbe pour les groupes d'histo
 */
export interface HistoricDataColor {
  /**
   * Identifiant de la donnée historisée
   */
  idDonnee: number;
  /**
   * Couleur associé à sa courbe représentative
   */
  couleur: string;
}

export enum DataPriority {
  /**
   * P1 – 7/7 urgent
   * @type {string}
   */
  P1 = 'P1',
  /**
   * P2 – 7/7 de jour
   * @type {string}
   */
  P2 = 'P2',
  /**
   * P3 – 5/7 HO
   * @type {string}
   */
  P3 = 'P3',
  /**
   * P4 – Alarme simple
   */
  P4 = 'P4',
  /**
   * P5 – Événement
   * @type {string}
   */
  P5 = 'P5',
  /**
   * P6 – Sans événement
   * @type {string}
   */
  P6 = 'P6',
  /**
   * P7 – Aucune
   * @type {string}
   */
  P7 = 'P7',
}

/**
 * Priorité des données blocables
 */
export const BLOCABLE_DATA_PRIORITYS: DataPriority[] = [DataPriority.P1, DataPriority.P2, DataPriority.P3];

/**
 * Type des données blocables
 */
export const BLOCABLE_DATA_TYPES: CrtDataType[] = [CrtDataType.TC, CrtDataType.TS, CrtDataType.TSP];

export const PRIORITE_LIBELLE: Record<DataPriority, string> = {
  P1: $localize`P1 - 7/7 jours fériés, intervention urgente`,
  P2: $localize`P2 - 7/7 jours fériés, intervention de jour`,
  P3: $localize`P3 - 5/7 hors jours fériés, intervention de jour`,
  P4: $localize`P4 - Défaut avec événement, pas d'envoi au CRC`,
  P5: $localize`P5 - Etat avec événement, pas d'envoi au CRC`,
  P6: $localize`P6 - Sans événement`,
  P7: $localize`P7 - Aucune`,
};
